'use client'
// Auto-generated by `npx boneyard-js build` — do not edit
import { registerBones } from 'boneyard-js'
import { configureBoneyard } from 'boneyard-js/react'

import _admin_rooms from './admin-rooms.bones.json'

configureBoneyard({ color: 'rgba(0,0,0,0.08)', animate: 'pulse' })

registerBones({
  'admin-rooms': _admin_rooms,
})
